<div [innerHTML]="htmlText | safeHtml"></div>
